module.exports = __webpack_public_path__ + "static/img/twjd-sdl6.d4e71f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdl6.png
// module id = 850
// module chunks = 0